import { Company } from '../../../types/company/Company'

export interface CustomerGroupQueryParams {
  companyId?: Company['id']
}

const customerGroupQueryKeys = {
  all: [{ scope: 'customerGroup' }] as const,
  lists: () => [{ ...customerGroupQueryKeys.all[0], entity: 'list' }] as const,
  list: (params: CustomerGroupQueryParams) => [{ ...customerGroupQueryKeys.lists()[0], ...params }] as const
}

export default customerGroupQueryKeys
